import LottiePlayer from "lottie-web";
import LottieView from "./components/lottie-view";
import useLottie from "./hooks/use-lottie";
import useLottieInteractivity from "./hooks/use-lottieInteractivity";

export { LottiePlayer, useLottie, useLottieInteractivity };

export default LottieView;
export * from "./types";
